import React from 'react'
import {Heading, Stack, VStack,Text,Button, Image, Box, HStack} from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import "../../styles/home.css"
import mainImg from "../../assets/images/education-logo-design.jpg"
import {CgGoogle,CgYoutube} from "react-icons/cg"
import {SiCoursera,SiUdemy} from "react-icons/si"
import {DiAws} from "react-icons/di"
import mainVideo from "../../assets/videos/Black General Subjects Online Education YouTube Video Ad.mp4"

const HomePage = () => {
  return (
    <section className='home'>
      <div className='container'>
        <Stack 
        direction={["column","row"]}
        height="100%"
        justifyContent={["center","space-between"]}
        alignItems="center"
        spacing={["16","56"]}
        >
          <VStack spacing='8' width={"full"} alignItems={["center","flex-end"]}>
            <Heading children="Excel in life" size={'2xl'} />
            <Text textAlign={['center','left']} children="Learn whatever you want from the best"/>
            <Link to="/courses">
              <Button size={"lg"} colorScheme="facebook">
                Explore more!
              </Button>
            </Link>
          </VStack>

          <Image className='vector-graphics' boxSize={"md"} src={mainImg} objectFit="contain" />

        </Stack>
      </div>

      <Box padding={"8"} bg="blackAlpha.800">
        <Heading textAlign={"center"} fontFamily="body" color="yellow.400" children="OUR PARTNERS"/>
        <HStack className='brandsBanner' justifyContent={'space-evenly'} marginTop="4">
          <CgGoogle/>
          <CgYoutube/>
          <SiCoursera/>
          <SiUdemy/>
          <DiAws/>
        </HStack>
      </Box>

      <div className='container2'>
        <video autoPlay 
        controls 
        controlsList="nodownload nofullscreen noremoteplayback" 
        disablePictureInPicture
        disableRemotePlayback
        src={mainVideo}
        >
        </video>
      </div>
    </section>
  )
}

export default HomePage